import React, { type FunctionComponent } from 'react'
import { SVGIcon } from 'ic-snacks'

interface AisleVisibilityIconProps {
  isAisleVisible: boolean
  isLoading?: boolean
}

const AisleVisibilityIcon: FunctionComponent<AisleVisibilityIconProps> = ({ isAisleVisible }) => {
  const name = isAisleVisible ? 'viewFilled' : 'view'

  return <SVGIcon name={name} />
}

export default AisleVisibilityIcon
